<div class="container mat-elevation-z6">
  <a *ngIf="item.route" [routerLink]="'/'+item.route">
    <img [src]="'assets/images/thumps/'+item.image">
    <div class="hover-overlay"><mat-icon class="flip">reply</mat-icon>{{item.title}}</div>
  </a>
  <div *ngIf="!item.route">
    <img [src]="item.image">
    <div class="hover-overlay">{{item.title}}</div>
  </div>
</div>

